async function asyncPool(concurrency, items, iteratorFn) {
  const executing = new Set();

  for (const item of items) {
    const p = (async () => iteratorFn(item))();
    executing.add(p);

    const clean = () => executing.delete(p);
    p.then(clean).catch(clean);

    if (executing.size >= concurrency) {
      await Promise.race(executing);
    }
  }

  await Promise.all(executing);
}

export default asyncPool;
